// Tracks the room code of a game the teacher is currently hosting, so the
// Dashboard can offer to rejoin it if they navigate away mid-game (the game
// itself lives only in server memory and the /host/:code route param, so
// this is what lets that fact survive a navigation to /dashboard).
const KEY = 'bingoRoomCode';

export function getActiveRoomCode() {
  return localStorage.getItem(KEY);
}

export function setActiveRoomCode(code) {
  localStorage.setItem(KEY, code);
}

export function clearActiveRoomCode() {
  localStorage.removeItem(KEY);
}
